import { useEffect } from "react";
import NavigationItem from "./NavigationItem";
import { useLocation } from "react-router-dom";
import { useData } from "data/data-provider";

function Navigation() {
  const location = useLocation();
  const { companyDetails } = useData();
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  // `lg:!flex`, not `lg:flex`: Meta's Event Setup Tool injects its own
  // unscoped Tailwind sheet after ours, and its plain `.hidden` / `.flex`
  // then out-cascade our breakpoint variants — at 1920px the desktop nav
  // vanished and the mobile hamburger appeared. `!important` on the
  // breakpoint variant keeps ours winning. The header CTA / menu trigger and
  // Design B's desktop/mobile hero swaps carry the same `!` for the same reason.
  return (
    <ul className="nc-Navigation hidden lg:!flex lg:flex-wrap lg:items-center lg:space-x-4 relative ">
      {companyDetails?.navigation_menu_items?.reduce((acc: any, item: any) => {
        acc.push(<NavigationItem key={item.id} menuItem={item} />);

        return acc;
      }, [])}
    </ul>
  );
}

export default Navigation;
